import { postUsageData, postBYODData } from './onboarding.api'
import labelsService from '../labels/labels.service'

class OnBoardingService {
  async postUsageData (usage) {
    try {
      await postUsageData(usage)
    } catch {
      
    } finally {
      labelsService.getLabels()
    }
  }

  async postBYODData (oldDomain, phoneNumber, timezone) {
    try {
      await postBYODData(oldDomain, phoneNumber, timezone)
    } catch {

    }
  }
}

export default new OnBoardingService()
